<script>
    import Icon from 'svelte-awesome';
    import { asterisk, pieChart } from 'svelte-awesome/icons';

    export let color = "white";
    export let scale = 4;
    export let light = false;
    export let height = 50;
    export let width = 50;
    export let style;

</script>

<div class="loading-spinner" class:light style="color: {color}; {style}">
<!--    <Icon {scale} data={pieChart} spin/>-->
<!--    <img src="/logo/evalueaid-symbol2.png" style="height: {scale * 32}px">-->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;display:block;" width="{width}px" height="{height}px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <circle cx="50" cy="50" fill="none" stroke="#cccccc" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.8620689655172413s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
        </circle>
    </svg>
</div>

<style>
    .loading-spinner {
        text-align:center;
    }

    .loading-spinner.light {
        filter: grayscale(1);
        opacity: 0.3;
    }

    .fas {
        margin: 10px;
    }

    img {
      animation-name: spin;
      animation-duration: 500ms;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }

    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }
</style>